import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';
import { AuthService } from '../security/auth.service';
import { InstallersService } from '../services/installers/installers.service';
import { UserImp } from '../services/users/users.interfaces';

/**
 * Resolver to fetch all timezones
 */
@Injectable()
export class CustomersResolver {
  private readonly installersService = inject(InstallersService);
  private readonly auth = inject(AuthService);


  resolve(): Observable<UserImp[]> {
    return this.installersService.getCustomers(this.auth.currentUserId());
  }
}
